module.exports = __webpack_public_path__ + "static/media/burn-details.1395808a.jpg";